export { default } from './VerticalTabsItem.js';
